import React from "react";

import Icon from "assets/icons";
import FormContainer from "shared/form";
import { InputType } from "shared/form/enum";
import Button from "shared/components/button";
import Validation from "shared/form/Validation";
import { ReAuthenticateUserType } from "./types";
import { useCopies } from "shared/hooks/useCopies";
import FormTextField from "shared/form/fields/textField";

export default function ReAuthenticateUser({ formRef, runPasswordValidation }: ReAuthenticateUserType) {
  const copies = useCopies();
  const [displayPassword, setDisplayPassword] = React.useState(false);

  const displayPasswordToggle = React.useCallback(e => {
    e.stopPropagation();
    e.preventDefault();
    setDisplayPassword(prevValue => !prevValue);
  }, []);

  const validateFn = React.useCallback(
    (val: any) => {
      let validator = runPasswordValidation
        ? Validation.passwordValidation({ copies: copies, required: true })
        : Validation.textFieldValidation({ copies: copies, required: true });
      return validator
        .validate(val)
        .then(() => undefined)
        .catch(({ errors }: any) => errors?.[0]);
    },
    [copies, runPasswordValidation]
  );

  return (
    <FormContainer innerRef={formRef} onSubmit={() => {}} initialValues={{ password: "" }}>
      <FormContainer.Form className="passwordForm">
        <FormTextField
          required
          name="password"
          switchIconPosition={true}
          label=""
          placeholder={copies.get("enter.password")}
          className="form_item--password"
          type={displayPassword ? InputType.TEXT : InputType.PASSWORD}
          icon={
            <Button
              icon={displayPassword ? <Icon.VisibilityOff /> : <Icon.VisibilityOn />}
              className="show-password"
              onClick={displayPasswordToggle}
              title={displayPassword ? copies.get("hide") : copies.get("show")}
            />
          }
          validate={validateFn}
        />
      </FormContainer.Form>
    </FormContainer>
  );
}
